import api from './api';

const timePeriodService = {
  async getTimePeriods(eventId) {
    const response = await api.get(`/events/${eventId}/time-periods`);
    return response.data;
  },

  async createTimePeriod(eventId, data) {
    const response = await api.post(`/events/${eventId}/time-periods`, data);
    return response.data;
  },

  async updateTimePeriod(eventId, periodId, data) {
    const response = await api.put(`/events/${eventId}/time-periods/${periodId}`, data);
    return response.data;
  },

  async deleteTimePeriod(eventId, periodId) {
    const response = await api.delete(`/events/${eventId}/time-periods/${periodId}`);
    return response.data;
  },

  async reorderTimePeriods(eventId, ids) {
    const response = await api.put(`/events/${eventId}/time-periods/reorder`, { ids });
    return response.data;
  },
};

export default timePeriodService;
